import React from 'react'

const Search = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M4 11c0-3.859 3.141-7 7-7s7 3.141 7 7-3.141 7-7 7-7-3.141-7-7m17.706 9.292l-3.678-3.678A8.953 8.953 0 0020 11c0-4.971-4.029-9-9-9s-9 4.029-9 9 4.029 9 9 9c2.125 0 4.074-.74 5.614-1.972l3.678 3.678a1 1 0 101.414-1.414" />
  </svg>
)

export default Search
